import { Paper, Theme, styled } from '@material-ui/core';
import Logo from '../Logo';
import bgPublicPagesJpg from '../../../../assets/bg_public_pages.jpg';
import bgPublicPagesWebp from '../../../../assets/bg_public_pages.webp';
import bgPublicPagesAvif from '../../../../assets/bg_public_pages.avif';
import checkMark from '../../../../assets/checkmark.svg';

export const FlexWrapper = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100%',
});

export const StyledLogoContainer = styled('div')({
  display: 'flex',
  justifyContent: 'start',
  marginBottom: '4rem',
});

export const TabletLogo = styled(Logo)<Theme>(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const Padding4Rem = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(4),
  minHeight: '100vh',
}));

export const BackgroundImage = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundImage: ` image-set(
    url(${bgPublicPagesAvif}) type("image/avif"),
    url(${bgPublicPagesWebp}) type("image/webp"),
    url(${bgPublicPagesJpg}) type("image/jpeg")
  );`,
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  opacity: 0.6,
});

export const RoundedPaper = styled(Paper)<Theme>(({ theme }) => ({
  position: 'relative',
  borderRadius: '2rem',
  padding: theme.spacing(4),
}));

export const TabletHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export const StyledPaper = styled(Paper)<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'left',
  background: theme.palette.grey['100'],
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
  },
  '&.full-size': {
    width: '100%',
    height: '100%',
    minHeight: '100vh',
  },
  '&.reset-password': {
    alignItems: 'center',
  },
  '&:not(.full-size)': {
    maxWidth: '47rem',
  },
}));

export const StyledContent = styled('div')<Theme, { showSmartScholl?: boolean }>(
  ({ theme, showSmartScholl }) => ({
    position: 'relative',
    zIndex: 1,
    borderBottom: `0.1rem solid ${theme.palette.grey['200']}`,
    width: '100%',
    padding: theme.spacing(4, 7, 0, 7),
    '&.reset-password': {
      flex: '1 1 0%',
      width: '400px',
      padding: theme.spacing(4),
      borderBottom: '0px',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4, 3, 0, 3),
        width: '80%',
      },
    },
  })
);

export const ResponsiveWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'block',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  marginBottom: '3rem',
  '& > div': {
    width: '100%',
    '&:first-child': {
      marginBottom: '5rem',
    },
  },
  '.two-columns': {
    display: 'flex',
    marginBottom: 0,
    '& > div': {
      width: 'calc(50% - 1.5rem)',
      '&:first-child': {
        marginBottom: 0,
      },
    },
  },
  '& ul.checklist': {
    margin: '0 0 3rem 0',
    padding: '0 0 0 2.5rem',
    listStyle: 'none',
    '& li': {
      position: 'relative',
      marginBottom: '1rem',
      '&:before': {
        position: 'absolute',
        top: '0.25rem',
        left: '-2.5rem',
        content: '',
        backgroundImage: `url(${checkMark})`,
        backgroundSize: 'cover',
        width: '1.6rem',
        height: '1.6rem',
      },
    },
  },
  '& .responsive-video': {
    position: 'relative',
    paddingBottom: '56.25%', // 16:9 ratio
    height: 0,
    '& iframe': {
      height: '26vh',
    },
  },
  '& a.button': {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.config.defaultBorderRadius,
    border: 'none',
    padding: '1.2rem 2rem',
    textTransform: 'uppercase',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '1.4rem',
  },
}));

export const Title = styled('h2')({
  marginTop: 0,
});

export const LinkDivider = styled('span')({
  padding: '0 0.5rem',
});
